/**
 * 宿主頁 getParentCookie 回覆裡，哪些值該拿來當 customer token。回傳 null 代表不要動 token。
 *
 * getParentCookie 這個指令有兩種來源：
 *  - bridge 回覆 notifyGetCookie：帶 { name, value, customerToken: value }。widget 除了要
 *    customer token，自由擺放（position: freedom）時也會要 launcher 位置 cookie，兩者的回覆
 *    長得一樣，只能靠 name 分辨。
 *  - MA SDK 切換身份（換成回訪會員的主客戶）：只帶 { customerToken }，沒有 name。
 *
 * 空值一律不覆蓋：首次來訪本來就沒有 token，覆蓋成空字串只會讓 SocketioLayer 重新產生身份。
 */
const customerTokenFromParentCookie = (options: any, tokenCookieName: string): string | null => {
	const name = options?.name;
	if (name && name !== tokenCookieName) {
		return null;
	}

	return options?.customerToken || null;
};

export default customerTokenFromParentCookie;
